<template>
  <div v-if="isMobile && !viewDesktopOnMobile" class="c-mobile-guard">
    <div class="w-full max-w-[400px]">
      <BittsSvg svg="computer" />
    </div>
    <h1>Switch to your desktop</h1>
    <p>Some features aren't mobile friendly.</p>
    <p>Use a desktop for the best experience.</p>
    <BittsButton
      type="neutral"
      variant="outline"
      size="small"
      text="View Anyway"
      class="mt-16"
      @click="viewDesktopOnMobile = true"
    />
  </div>
  <template v-else>
    <slot />
  </template>
</template>

<script setup lang="ts">
import { BittsButton, BittsSvg } from '@crossbeam/bitts';
import { useScreenSize } from '@crossbeam/pointbreak';

import { ref } from 'vue';

const { isMobile } = useScreenSize();
const viewDesktopOnMobile = ref(false);
</script>

<style lang="pcss">
@reference "../css/theme.css";
.c-mobile-guard {
  @apply flex flex-col items-center px-16 py-40;

  h1 {
    @apply mt-24 font-bold text-xl text-neutral-text-strong;
  }

  p {
    @apply text-neutral-text text-m text-center;
  }
}
</style>
